<template>
  <v-navigation-drawer
    v-model="drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-list nav>
      <v-list-item class="mt-0 mb-0">
        <v-list-item-content>
          <img
            src="@/assets/logo.png"
            align-center
            justify-center
            width="100%"
          />
        </v-list-item-content>
      </v-list-item>
      <template v-for="(item, index) in items">
        <v-list-item
          class="mb-n2"
          v-if="item.heading"
          :key="`${item.text}${index}`"
        >
          <v-list-item-content>
            <v-list-item-title class="headline">{{
              item.heading
            }}</v-list-item-title>
            <v-list-item-subtitle class="mt-1" v-if="item.subtitle">{{
              item.subtitle
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2" v-else-if="item.divider" :key="index" />
        <v-list-item
          class="mt-0 mb-0"
          v-else-if="item.externalLink"
          :key="`${item.text}${index}`"
          link
          :href="item.externalLink"
          color="primary"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          class="mt-0 mb-0"
          v-else
          :key="`${item.text}${index}`"
          link
          :to="{ name: item.routeName, params: item.routeParams }"
					exact
					:active="false"
          color="primary"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Drawer',

  data: () => ({
  }),

  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(value) {
        this.$store.commit('toggleDrawer', value)
      }
    },
    items: function () {
      const items = [
        { divider: true },
        {
          text: "Home",
          externalLink: "https://www.pickaservice.ky/",
        },
        {
          text: "About Us",
          externalLink: "https://www.pickaservice.ky/about-us",
        },
        {
          text: "Services",
          externalLink: "https://www.pickaservice.ky/services",
        },
        {
          text: "Contact",
          externalLink: "https://www.pickaservice.ky/contact",
        },
        {
          text: "Shipping Calculator",
          routeName: "calculator",
					path: '/calculator/',
          routeParams: {}
        },
        {
          text: "Track Your Packages",
          routeName: "tracker-form",
          routeParams: {}
        },
      ]
      return items
    },
  }

};
</script>
